import Vue from "vue";
import Router from "vue-router";
const AttendanceRule = resolve =>
  require(["../page/AttendanceRule/AttendanceRule.vue"], resolve);
const AddAttendanceRule = resolve =>
  require(["../page/AttendanceRule/AddAttendanceRule.vue"], resolve);

const AttendanceRuleDetail = resolve =>
  require(["../page/AttendanceRule/AttendanceRuleDetail.vue"], resolve);
const AttendanceArrange = resolve =>
  require([
    "../page/AttendanceSort/AttendanceArrange/AttendanceArrange.vue"
  ], resolve);
const FirstAddArrange = resolve =>
  require([
    "../page/AttendanceSort/AttendanceMange/AddArrange/FirstAddArrange.vue"
  ], resolve);
const TwiceAddArrange = resolve =>
  require([
    "../page/AttendanceSort/AttendanceMange/AddArrange/TwiceAddArrange.vue"
  ], resolve);
const ThirdAddArrange = resolve =>
  require([
    "../page/AttendanceSort/AttendanceMange/AddArrange/ThirdAddArrange.vue"
  ], resolve);
const AttendanceArrangeDeatil = resolve =>
  require([
    "../page/AttendanceSort/AttendanceArrange/AttendanceArrangeDeatil.vue"
  ], resolve);
const FirstEduitArrange = resolve =>
  require([
    "../page/AttendanceSort/AttendanceMange/EduitArrange/FirstEduitArrange.vue"
  ], resolve);
const TwiceEduitArrange = resolve =>
  require([
    "../page/AttendanceSort/AttendanceMange/EduitArrange/TwiceEduitArrange.vue"
  ], resolve);
const ThirdEduitArrange = resolve =>
  require([
    "../page/AttendanceSort/AttendanceMange/EduitArrange/ThirdEduitArrange"
  ], resolve);

const AddAttendanceArrange = resolve =>
  require([
    "../page/AttendanceSort/AttendanceArrange/AddAttendanceArrange.vue"
  ], resolve);
const AttendanceMange = resolve =>
  require([
    "../page/AttendanceSort/AttendanceMange/AttendanceMange.vue"
  ], resolve);
const AttendanceStatistics = resolve =>
  require(["../page/AttendanceStatistics/AttendanceStatistics.vue"], resolve);
const OutStatistics = resolve =>
  require(["../page/AttendanceStatistics/OutStatistics.vue"], resolve);
const ReplenishStatistics = resolve =>
  require(["../page/AttendanceStatistics/ReplenishStatistics.vue"], resolve);
const EvectionStatistics = resolve =>
  require(["../page/AttendanceStatistics/EvectionStatistics.vue"], resolve);
const LeaveStatistics = resolve =>
  require(["../page/AttendanceStatistics/LeaveStatistics.vue"], resolve);
const Statistics = resolve =>
  require(["../page/AttendanceStatistics/Statistics.vue"], resolve);
const BatchOperation = resolve =>
  require(["../page/AttendanceStatistics/BatchOperation.vue"], resolve);

const AttendanceClock = resolve =>
  require(["../page/AttendanceStatistics/AttendanceClock.vue"], resolve);
const AttendanceCollect = resolve =>
  require(["../page/AttendanceStatistics/AttendanceCollect.vue"], resolve);
const AttendanceWay = resolve =>
  require(["../page/AttendanceWay/AttendanceWay.vue"], resolve);
//人员管理
const PersonMange = resolve =>
  require(["../page/PersonMange/PersonMange.vue"], resolve);
const PersonInfoImport = resolve =>
  require(["../page/PersonMange/PersonInfoImport.vue"], resolve);
const PersonInfoImportOld = resolve =>
  require(["../page/PersonMange/PersonInfoImportOld.vue"], resolve);
// 加班规则
const OverTimeRuleList = resolve =>
  require(["../page/OverTimeRule/OverTimeRuleList.vue"], resolve);
const OverTimeRuleListDetail = resolve =>
  require(["../page/OverTimeRule/OverTimeRuleListDetail.vue"], resolve);
const addOverTimeRuleList = resolve =>
  require(["../page/OverTimeRule/addOverTimeRuleList.vue"], resolve);
// 新增报表
const AttendanceStatement = resolve =>
  require(["../page/AttendanceStatement/AttendanceStatement.vue"], resolve);
// 加班管理

const OverTimeRest = resolve =>
  require(["../page/OverTimeManage/OverTimeRest.vue"], resolve);
const OverTimeRestDetail = resolve =>
  require(["../page/OverTimeManage/OverTimeRestDetail.vue"], resolve);
// // 假期管理
// const HolidaySet = resolve => require(["../page/Holiday/HolidaySet/HolidaySet.vue"], resolve)// 假期设置
// const HolidayBalance = resolve => require(["../page/Holiday/HolidayBalance/HolidayBalance.vue"], resolve)//假期余额
// const HolidayBalanceDetail = resolve => require(["../page/Holiday/HolidayBalance/HolidayBalanceDetail.vue"], resolve)//假期余额
// const HolidayCalendar = resolve => require(["../page/Holiday/HolidayCalendar/HolidayCalendar.vue"], resolve)//假期日历
// const HolidayRecord = resolve => require(["../page/Holiday/HolidayRecord/HolidayRecord.vue"], resolve)//假期记录
// const HolidaySetDetail = resolve => require(["../page/Holiday/HolidaySet/HolidaySetDetail.vue"], resolve)//假期记录
// 假期
const VacationSet = resolve =>
  require(["../page/Vacation/VacationSet.vue"], resolve); //假期设置
const VacationBalance = resolve =>
  require(["../page/Vacation/VacationBalance.vue"], resolve); //假期余额(旧)
const VacationBalanceNew = resolve =>
  require(["../page/VacationBalanceNew/VacationBalanceNew.vue"], resolve); //假期余额(旧)
const LeaveRecord = resolve =>
  require(["../page/Vacation/LeaveRecord.vue"], resolve); //假期记录
const ReviewRecords = resolve =>
  require(["../page/Examine/ReviewRecords.vue"], resolve); //假期审批管理
//假期类型
const VacationType = resolve =>
  require(["../page/VacationType/VacationType.vue"], resolve);
const ApprovalSetting = resolve =>
  require(["../page/VacationType/ApprovalSetting.vue"], resolve);

//审批管理
const Auditing = resolve => require(["../page/Auditing/Auditing.vue"], resolve);
const Auditingdetails = resolve =>
  require(["../page/Auditing/Auditingdetails.vue"], resolve);

//异常设备管理
const AbnormalDevice = resolve =>
  require(["../page/AbnormalDevice/index.vue"], resolve);

//排班管理
const ShiftManagementList = resolve =>
  require(["../page/ShiftManagement/index.vue"], resolve);
const ScheduleEdit = resolve =>
  require(["../page/ShiftManagement/schedule.vue"], resolve);
const ImportExport = resolve =>
  require(["../page/ShiftManagement/ImportExport.vue"], resolve);

//套餐
const PackageIndex =resolve=>require(["../page/Package/PackageIndex.vue"],resolve);
const PackageBuy =resolve=>require(["../page/Package/PackageBuy.vue"],resolve);
const PackageSubmit =resolve=>require(["../page/Package/PackageSubmit.vue"],resolve);

//订单
const OrderManage = resolve=>require(["../page/Order/OrderManage.vue"],resolve);
const OrderSubmit = resolve=>require(["../page/Order/OrderSubmit.vue"],resolve);
const OrderDetail = resolve=>require(["../page/Order/OrderDetail.vue"],resolve);

// 部门管理
const DepartmentMange = resolve=>require(["../page/DepartmentMange/index.vue"],resolve);

Vue.use(Router);

export default new Router({
  routes: [
    { path: "/", redirect: "AttendanceRule" },
    {
      path: "/AttendanceRule",
      name: "AttendanceRule",
      component: AttendanceRule
    },
    {
      path: "/AddAttendanceRule",
      name: "AddAttendanceRule",
      component: AddAttendanceRule
    },
    {
      path: "/AttendanceRuleDetail",
      name: "AttendanceRuleDetail",
      component: AttendanceRuleDetail
    },
    {
      path: "/Statistics",
      name: "Statistics",
      component: Statistics,
      children: [
        {
          path: "/",
          component: AttendanceStatistics
        },
        {
          path: "/Statistics/OutStatistics",
          component: OutStatistics
        },
        {
          path: "/Statistics/ReplenishStatistics",
          component: ReplenishStatistics
        },
        {
          path: "/Statistics/EvectionStatistics",
          component: EvectionStatistics
        },
        {
          path: "/Statistics/LeaveStatistics",
          component: LeaveStatistics
        }
      ]
    },

    {
      path: "/BatchOperation",
      name: "BatchOperation",
      component: BatchOperation
    },

    {
      path: "/AttendanceCollect",
      name: "AttendanceCollect",
      component: AttendanceCollect
    },
    {
      path: "/AttendanceClock",
      name: "AttendanceClock",
      component: AttendanceClock
    },
    {
      path: "/AttendanceArrange",
      name: "AttendanceArrange",
      component: AttendanceArrange
    },
    {
      path: "/FirstAddArrange",
      name: "FirstAddArrange",
      component: FirstAddArrange
    },
    {
      path: "/TwiceAddArrange",
      name: "TwiceAddArrange",
      component: TwiceAddArrange
    },
    {
      path: "/ThirdAddArrange",
      name: "ThirdAddArrange",
      component: ThirdAddArrange
    },
    {
      path: "/FirstEduitArrange",
      name: "FirstEduitArrange",
      component: FirstEduitArrange
    },
    {
      path: "/TwiceEduitArrange",
      name: "TwiceEduitArrange",
      component: TwiceEduitArrange
    },
    {
      path: "/ThirdEduitArrange",
      name: "ThirdEduitArrange",
      component: ThirdEduitArrange
    },
    {
      path: "/AttendanceArrangeDeatil",
      name: "AttendanceArrangeDeatil",
      component: AttendanceArrangeDeatil
    },
    {
      path: "/AddAttendanceArrange",
      name: "AddAttendanceArrange",
      component: AddAttendanceArrange
    },
    {
      path: "/AttendanceMange",
      name: "AttendanceMange",
      component: AttendanceMange
    },
    { path: "/AttendanceWay", name: "AttendanceWay", component: AttendanceWay },
    { path: "/PersonMange", name: "PersonMange", component: PersonMange },
    {
      path: "/PersonInfoImport",
      name: "PersonInfoImport",
      component: PersonInfoImport
    },
    {
      path: "/PersonInfoImportOld",
      name: "PersonInfoImportOld",
      component: PersonInfoImportOld
    },
    {
      path: "/OverTimeRuleList",
      name: "OverTimeRuleList",
      component: OverTimeRuleList
    },
    {
      path: "/OverTimeRuleListDetail",
      name: "OverTimeRuleListDetail",
      component: OverTimeRuleListDetail
    },
    {
      path: "/addOverTimeRuleList",
      name: "addOverTimeRuleList",
      component: addOverTimeRuleList
    },
    {
      path: "/AttendanceStatement",
      name: "AttendanceStatement",
      component: AttendanceStatement
    },
    // 加班管理
    // { path: '/OverTimeTime', name: 'OverTimeTime', component: OverTimeTime },
    { path: "/OverTimeRest", name: "OverTimeRest", component: OverTimeRest },
    {
      path: "/OverTimeRestDetail",
      name: "OverTimeRestDetail",
      component: OverTimeRestDetail
    },
    // // 假期设置
    // { path: '/HolidaySet', name: 'HolidaySet', component: HolidaySet },
    // { path: '/HolidaySetDetail', name: 'HolidaySetDetail', component: HolidaySetDetail },
    // // 假期余额
    // { path: '/HolidayBalance', name: 'HolidayBalance', component: HolidayBalance },
    // { path: '/HolidayBalanceDetail', name: 'HolidayBalanceDetail', component: HolidayBalanceDetail },
    // // 假期日历
    // { path: '/HolidayCalendar', name: 'HolidayCalendar', component: HolidayCalendar },
    // { path: '/HolidayRecord', name: 'HolidayRecord', component: HolidayRecord },

    // 假期
    { path: "/VacationSet", name: "VacationSet", component: VacationSet },
    {
      path: "/VacationBalance",
      name: "VacationBalance",
      component: VacationBalance
    },
    { path: "/LeaveRecord", name: "LeaveRecord", component: LeaveRecord },
    { path: "/ReviewRecords", name: "ReviewRecords", component: ReviewRecords },

    //假期类型
    { path: "/VacationType", name: "VacationType", component: VacationType },
    {
      path: "/ApprovalSetting",
      name: "ApprovalSetting",
      component: ApprovalSetting
    },
    {
      path: "/VacationBalanceNew",
      name: "VacationBalanceNew",
      component: VacationBalanceNew
    },

    //审批管理
    { path: "/Auditing", name: "Auditing", component: Auditing },
    {
      path: "/Auditingdetails",
      name: "Auditingdetails",
      component: Auditingdetails
    },

    //异常设备管理
    {
      path: "/AbnormalDevice",
      name: "AbnormalDevice",
      component: AbnormalDevice
    },

    //排班管理
    {
      path: "/ShiftManagementList",
      name: "ShiftManagementList",
      component: ShiftManagementList
    },
    { path: "/ScheduleEdit", name: "ScheduleEdit", component: ScheduleEdit },
    { path: "/ImportExport", name: "ImportExport", component: ImportExport },
    //套餐
    { path:"/PackageIndex",name:"PackageIndex",component:PackageIndex},
    { path:"/PackageBuy",name:"PackageBuy",component:PackageBuy},
    { path:"/PackageSubmit",name:"PackageSubmit",component:PackageSubmit},
    // 订单
    { path:"/OrderManage",name:"OrderManage",component:OrderManage},
    { path:"/OrderSubmit",name:"OrderSubmit",component:OrderSubmit},
    { path:"/OrderDetail",name:"OrderDetail",component:OrderDetail},
    // 部门管理
    { path: "/DepartmentMange", name: "DepartmentMange", component: DepartmentMange },
    
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js